<div class="lg:grid lg:grid-flow-row lg:grid-cols-5 lg:gap-x-8 lg:items-start" kbStickyAnchorContainer>
    <div class="lg:col-span-3">
        <kb-asset-gallery
            [assets]="product?.assets ?? []"
            [selectedAssetId]="product?.featuredAsset?.id"
            [videoUrls]="product?.customFields?.videoUrls"
            [productName]="productPreview?.name"
        ></kb-asset-gallery>
    </div>
    <div class="mt-10 px-4 sm:px-0 sm:mt-16 lg:mt-0 lg:col-span-2">
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
            {{ productPreview?.name }}
        </h1>
        <kb-brand-label [product]="product"></kb-brand-label>
        <kb-star-rating
            [rating]="productPreview?.customFields?.reviewRating || 0"
            [reviewCount]="productPreview?.customFields?.reviewCount || 0"
            reviewCountAnchor="reviews"
            class="block mb-4"
        ></kb-star-rating>
        <div kbStickyAnchor>
            <div>
                <vsf-dropdown #dropdown [position]="['bottom']" [closeOnItemClick]="true" widthClass="w-96">
                    <button
                        vsfDropdownTrigger
                        class="w-full hover:bg-gray-50 rounded border border-gray-300 shadow-sm hover:shadow"
                    >
                        <div
                            class="flex space-x-4 justify-between items-center p-2"
                            *ngIf="selectedVariant; else noSelection"
                        >
                            <div>
                                <div class="text-left">
                                    <span *ngFor="let option of selectedVariant?.options">
                                        {{ option.name }}
                                    </span>
                                </div>
                                <div class="flex space-x-2 text-sm">
                                    <div class="text-gray-500">
                                        {{ selectedVariant?.sku }}
                                    </div>
                                    <kb-stock-level-label
                                        [stockLevel]="selectedVariant?.stockLevel"
                                    ></kb-stock-level-label>
                                    <kb-in-cart-label
                                        [inCartQty]="inCartQty[selectedVariant?.id]"
                                    ></kb-in-cart-label>
                                </div>
                            </div>
                            <div
                                class="font-medium text-lg text-red-700 opacity-70 line-through"
                                *ngIf="selectedVariant.customFields.rrp as rrp"
                                title="RRP"
                            >
                                {{ rrp | formatPrice }}
                            </div>
                            <div class="flex-1"></div>
                            <div
                                class="font-medium text-lg text-gray-800"
                                [class.line-through]="selectedVariant.stockLevel === 'OUT_OF_STOCK'"
                            >
                                {{ selectedVariant?.priceWithTax | formatPrice }}
                            </div>
                            <fa-icon [icon]="chevronDown" class="text-gray-600"></fa-icon>
                        </div>
                        <ng-template #noSelection>
                            <div class="flex space-x-4 justify-between items-center p-2">
                                <div class="text-left font-medium text-red-700">
                                    {{ selectText }}
                                </div>
                                <fa-icon [icon]="chevronDown" class="text-gray-600"></fa-icon>
                            </div>
                        </ng-template>
                    </button>
                    <div class="card divide-y" vsfDropdownContent>
                        <button
                            (click)="selectedVariant = variant"
                            [disabled]="variant.stockLevel === 'OUT_OF_STOCK'"
                            *ngFor="let variant of product?.variants"
                            [ngClass]="{
                                'opacity-70': variant.stockLevel === 'OUT_OF_STOCK',
                                'hover:bg-gray-50': variant.stockLevel !== 'OUT_OF_STOCK'
                            }"
                            class="flex items-center w-full space-x-4 justify-between p-2"
                        >
                            <div>
                                <div class="text-left">
                                    <span *ngFor="let option of variant.options">
                                        {{ option.name }}
                                    </span>
                                </div>
                                <div class="flex items-center space-x-2 text-sm">
                                    <div class="text-gray-500">
                                        {{ variant?.sku }}
                                    </div>
                                    <kb-stock-level-label
                                        [stockLevel]="variant?.stockLevel"
                                    ></kb-stock-level-label>
                                    <kb-in-cart-label [inCartQty]="inCartQty[variant?.id]"></kb-in-cart-label>
                                </div>
                            </div>
                            <div
                                class="font-medium text-lg text-red-700 opacity-70 line-through"
                                *ngIf="variant.customFields.rrp as rrp"
                                title="RRP"
                            >
                                {{ rrp | formatPrice }}
                            </div>
                            <div
                                class="font-medium text-lg text-gray-800"
                                [class.line-through]="variant.stockLevel === 'OUT_OF_STOCK'"
                            >
                                {{ variant?.priceWithTax | formatPrice }}
                            </div>
                        </button>
                    </div>
                </vsf-dropdown>

                <kb-shipping-info-label [shippingInfo]="shippingInfo$ | async"></kb-shipping-info-label>
                <div class="mt-4" *ngIf="selectedVariant">
                    <kb-selected-variant-controls
                        [inCartQty]="inCartQty[selectedVariant.id]"
                        (addToCartClick)="addToCartClick.emit($event)"
                        (setQuantity)="manuallySetQuantity(selectedVariant.id, $event)"
                        [adjustedQty]="adjustedQty"
                        [selectedVariant]="selectedVariant"
                    ></kb-selected-variant-controls>
                    <kb-add-to-wishlist-button
                        class="block mt-2"
                        [disabled]="selectedVariant == null"
                        [inWishlists]="variantAppearsInWishlists(selectedVariant?.id)"
                        [variantId]="selectedVariant?.id"
                        (addClick)="
                            addToWishlistClick.emit({
                                productVariantId: selectedVariant?.id,
                                wishlistId: $event
                            })
                        "
                    ></kb-add-to-wishlist-button>
                </div>
                <kb-offer-label [product]="product"></kb-offer-label>
                <div
                    *ngIf="productPreview.customFields.keyFeatures"
                    class="prose max-w-none mt-6"
                    [innerHTML]="productPreview.customFields.keyFeatures"
                ></div>
            </div>
        </div>
    </div>
    <div class="lg:col-span-3">
        <kb-tabbed-description
            [description]="productPreview.description"
            class="block mt-4"
        ></kb-tabbed-description>
    </div>
    <div></div>
</div>
